import { TranslateFn } from '@blocs.i18n';
import { gqlOrganizationStatusEnum } from '@minecraft.graphql-types';

export const getAuthorizationErrorMessage = (t: TranslateFn, error) => {
  const accountStatusCode = error?.graphQLErrors?.[0]?.data?.errorData?.accountStatusCode;
  switch (accountStatusCode) {
    case gqlOrganizationStatusEnum.UNCLAIMED:
      return t('login:login.error.googleAuthenticationFailed.accountUnclaimed');
    case gqlOrganizationStatusEnum.CLOSED:
      return t('login:login.error.googleAuthenticationFailed.accountClosed');
    case gqlOrganizationStatusEnum.JOINED:
      return t('login:login.error.googleAuthenticationFailed.accountJoined');
    default:
      return error?.graphQLErrors?.[0]?.message;
  }
};

export default getAuthorizationErrorMessage;
